import logo from '../assets/haio-logo.png'

export default function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <header className="ho-header">
      <Sweep />
      <img className="ho-logo" src={logo} alt="Sahajidah Hai-O" />
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </header>
  )
}

export function Wave() {
  return (
    <svg className="ho-wave" viewBox="0 0 402 64" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 64V54C120 42 250 14 352 4C380 1 402 10 402 22V64Z" fill="#fce7e5" />
    </svg>
  )
}

// Red corner deco, top-right of every screen (design: 170×170).
export function Sweep() {
  return (
    <svg className="ho-sweep" viewBox="0 0 170 170" aria-hidden="true">
      <path d="M0 0C68 20 148 80 170 168V0Z" fill="currentColor" />
    </svg>
  )
}
